export { default } from './SpotDetails';
